import React from "react";
import ApexCharts from "react-apexcharts"; 

const StackedChartComponent = ({ progressSums, progressOptions, type }) => {

  const chartOptions = {
    chart: {
      id: "progress-chart",
      type: "bar", 
      height: 350,
      stacked: true,
      stackType: '100%',
    },
    xaxis: {
      categories: progressOptions.map(option => option.label || option.name),
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        
      },
    },
    responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    tooltip: {
      enabled: true,
    },
    fill: {
      opacity: 1
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex];
    }}
  };

  // Prepare chart series with stacked data for each user
  const chartSeries = progressSums.map(user => ({
    name: user.name,
    data: user.data,
  }));

  return (
    <div id="chart">
      <ApexCharts options={chartOptions} series={chartSeries} type="bar" height={350} />
    </div>
  );
};

export default StackedChartComponent;
